var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatApagadoA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.666,
    height: 15.139,
    viewBox: "0 0 13.666 15.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-431.414 -736.071)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(322.402 200.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.248,65.248a6.717,6.717,0,0,1-6.411-6A6.616,6.616,0,0,1,165,53.373a.934.934,0,1,1,1.249,1.369,4.984,4.984,0,0,0,2.169,8.5,4.976,4.976,0,0,0,4.528-8.52.956.956,0,0,1-.31-.972.869.869,0,0,1,.669-.654.9.9,0,0,1,.877.242,6.679,6.679,0,0,1,2.179,4.027,6.827,6.827,0,0,1-4.246,7.4A7.158,7.158,0,0,1,169.248,65.248Z",
    transform: "translate(-53.766 485.221)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.6,20.658c0,.8,0,1.6,0,2.4a.924.924,0,1,1-1.843,0q0-2.4,0-4.792a.924.924,0,1,1,1.843,0C236.606,19.06,236.6,19.859,236.6,20.658Z",
    transform: "translate(-119.84 518.055)",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatApagadoA);
export default __webpack_public_path__ + "static/media/LAT-APAGADO-A.60d1d256e3fea67d72a142b71d54d697.svg";
export { ForwardRef as ReactComponent };